uniform float uAlpha;
uniform float uProgress; // 0.0から1.0まで進行する値

varying vec2 vUv;

void main()
{
    vec2 center = vec2(0.5, 0.5);
    float dist = distance(center, vUv);
    float alpha = dist + 0.5 - uProgress;

    gl_FragColor = vec4(0.0, 0.0, 0.0, alpha);
}